import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { SnIncident } from '@lib/api/entities';

@Component({
  selector: 'sn-incident-details',
  templateUrl: './incident-details.component.html',
  styleUrls: ['./incident-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncidentDetailsComponent {
  @Input()
  public incident: SnIncident;

  constructor() {}
}
